  export class ConfigDB {
    static data = {
      settings: {
        layout_type: 'ltr',
        sidebar: {
          type: 'compact-wrapper',
        },
        sidebar_setting: 'default-sidebar',
      },
      color: {
        primary_color: '#39B54A',
        secondary_color: '#f73164',
        mix_background_layout: 'light-only',
      },
      router_animation: 'fadeIn',
    };
  }
  export default ConfigDB;
